import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { UpdateLocationContactInput } from './UpdateLocationContactInput';
import { UpdateLocationContactOutput } from './UpdateLocationContactOutput';

export class UpdateLocationContactService extends HttpServiceBase {

  handle = (input: UpdateLocationContactInput): Promise<Result<UpdateLocationContactOutput> | null> => {
    const { id, ...contact } = input;
    return this.http.patch<Result<UpdateLocationContactOutput>, typeof contact>(`${this.baseUrlSislogApi}/v2/location/admin/${id}/contact`, contact);
  }
}
